// extracted by mini-css-extract-plugin
export default {"root":"_16xOxYXh","icon":"BzF9ozYT","title":"_3s9Zed-X","subTitle":"_3FQsGQSI","orderTitle":"_1NfpeMBe"};